import {
    useState,
    useEffect,
} from 'react';
import {
    Container,
    BoxSelect,
    BtnSearch,
    FilterWrapper,
    Content,
    Title
} from './styled';
import { ChartUser } from './ChartUser';
import { DatePicker, InputList, Search } from '../../../../components';
import { IoIosSearch } from 'react-icons/io';
import moment from 'moment';
import { apiAdmin } from '../../../../service/api';
import { CgPerformance } from "react-icons/cg";


export function PerformanceByUsers() {

    const [dateStart, setDateStart] = useState(
        moment().subtract(6, 'months').format('YYYY-MM-DD')
    );
    const [dateEnd, setDateEnd] = useState(
        moment().format('YYYY-MM-DD')
    );
    const vision_type = [
        {
            id: 0,
            name: 'Total - Mensal',
            value: 'M',
        },
        {
            id: 1,
            name: 'Total - Semanal',
            value: 'W',
        }, {
            id: 2,
            name: 'Total - Diário',
            value: 'D',
        }
    ];
    const [visionTypeSelected, setVisionTypeSelected] = useState({
        id: 0,
        name: 'Total - Mensal',
        value: 'M',
    });
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState('');


    const searchDataCompanies = async (dateStart, dateEnd, type) => {
        try {
            setLoading(true);
            setUsers([]);
            const { data } = await apiAdmin.post(`/atendimentos-usuario-visao?dt_ini=${dateStart}&dt_fim=${dateEnd}&tipo_visao=${type}`);
            const { dados } = data[0];
            setUsers(groupByName(dados))
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const groupByName = (array) => {
        return (array).reduce((acc, obj) => {
            const existingGroup = acc.find(group => group[0].usuario === obj.usuario);
            if (existingGroup) {
                existingGroup.push(obj);
            } else {
                acc.push([obj]);
            }
            return acc;
        }, []);
    };
    useEffect(() => {
        searchDataCompanies(
            moment(dateStart).format('DD/MM/YYYY'),
            moment(dateEnd).format('DD/MM/YYYY'),
            visionTypeSelected.value
        )
    }, []);

    function onFilter(obj) {
        return obj[0]?.usuario?.toLowerCase()?.includes(filter?.toLowerCase())
            || obj[0]?.usuario?.toLowerCase()?.includes(filter?.toLowerCase());
    };

    return (
        <Container>
            <BoxSelect>
                <div className='box--'>
                    <div className='line-'>
                        <DatePicker
                            className="date"
                            value={dateStart}
                            onChange={setDateStart}
                        />
                        <span> - </span>
                        <DatePicker
                            className="date"
                            value={dateEnd}
                            onChange={setDateEnd}
                        />
                    </div>
                    <div className='line-'>
                        <div className='list-'>
                            <InputList
                                options={vision_type}
                                value={visionTypeSelected?.name}
                                onChange={(e) => { setVisionTypeSelected(e) }}
                                toView={'name'}
                            />
                        </div>
                        <BtnSearch
                            disabled={loading ? 1 : 0}
                            onClick={() => {
                                searchDataCompanies(
                                    moment(dateStart).format('DD/MM/YYYY'),
                                    moment(dateEnd).format('DD/MM/YYYY'),
                                    visionTypeSelected.value
                                )
                            }}
                        >
                            {loading
                                ? <span className='loader' />
                                : <IoIosSearch />
                            }
                        </BtnSearch>
                    </div>
                </div>
            </BoxSelect>
            <Title>
                <span>
                    <CgPerformance fontSize={'3rem'} />
                </span>
                <div>
                    {`Total de atendimentos e clientes por usuário`}
                </div>
            </Title>
            <FilterWrapper className={users.length === 0 && 'disabled'}>
                <Search
                    className='input-filter'
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    placeholder={`Buscar Usuário`}
                />
            </FilterWrapper>
            <Content>
                {users?.filter(onFilter)?.map((user) => {
                    const { usuario } = user[0];
                    const objKey = {
                        'M': 'mes_extenso',
                        'W': 'semana',
                        'D': 'dia'
                    }
                    return (
                        <ChartUser
                            key={usuario}
                            user={user}
                            objKey={objKey[visionTypeSelected.value]}
                            className="chart"
                        />
                    )
                })}
            </Content>
        </Container >
    );
}
